export default "<div class=\"tab-panel padded\">\n  <tab-panel-content></tab-panel-content>\n</div>\n"